import { APIClient } from "./axiosClient";

const api = new APIClient();

const path = "/banners";
const pathPosition = "/banners/positions";

const bannerApi = {
  getBannerPositionList(params: any): Promise<any> {
    const url = `${pathPosition}`;
    return api.get(url, params);
  },

  createBannerPosition(params: any) {
    const url = `${pathPosition}`;
    return api.post(url, params);
  },

  updateBannerPosition(id: any, params: any) {
    return api.put(`${pathPosition}/${id}`, params);
  },

  deleteBannerPosition(id: any) {
    return api.delete(`${pathPosition}/${id}`);
  },

  getBannerList(params: any = {}) : Promise<any>  {
    const url = `${path}`;
    return api.get(url, params)
  },

  createBanner(params: any) {
    const url = `${path}`;
    return api.post(url, params);
  },

  updateBanner(id: any, params: any) {
    return api.put(`${path}/${id}`, params);
  },

  deleteBanner(id: any) {
    return api.delete(`${path}/${id}`);
  },
};

export default bannerApi;
